module.exports = __webpack_public_path__ + "static/media/icn-safari.0d05e389.png";